import { mapState } from 'vuex';
import styled from 'vue-styled-components';
import { fontSize } from 'styled-system';
import { Section, Center, Row, Col } from '@styled/global';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n   font-weight: 500;\n   padding: 0;\n   margin: 20px 0 0 0;\n   line-height: normal;\n   justify-content: center;\n   align-items: center;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n   font-size: 1.17em;\n   font-weight: bold;\n   padding: 0;\n   margin: 0 0 20px 0;\n   line-height: normal;\n   text-align: center;\n   color: #000;\n   -webkit-font-smoothing: antialiased;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n   padding: 10px;\n   text-align: center;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   display: flex;\n   width: 100%;\n   line-height: normal;\n   -webkit-font-smoothing: antialiased;\n   justify-content: center;\n   align-items: center;\n   font-weight: normal;\n   margin: 20px 0 20px 0;\n   text-shadow: 1px 1px 1px #000;\n   color: #fff;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n   ", "\n\n   display: flex;\n   width: 100%;\n   -webkit-font-smoothing: antialiased;\n   justify-content: center;\n   align-items: center;\n   font-weight: bold;\n   margin: 20px 0 0 0;\n   color: #fff;\n   text-shadow: 1px 1px 2px #000;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n   display: flex;\n   flex-direction: row;\n   flex-wrap: wrap;\n   align-content: stretch;\n   align-items: stretch;\n   justify-content: space-between;\n   margin: 40px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n   background: rgba(255, 255, 255, 0.7);\n   border-radius: 10px;\n   box-shadow: 1px 1px 5px 5px rgba(0, 0, 0, 0.4);\n   border: 5px solid #fff;\n   margin-top: 10px;\n   height: 100%;\n   width: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var Block = styled("div", {})(_templateObject());
var BlockWrapper = styled("div", {})(_templateObject2());
var SectionHeader = styled("h2", {
  fontSize: {
    default: function _default() {
      return [3, 3, 4, 6];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject3(), fontSize);
var SectionFooter = styled("div", {
  fontSize: {
    default: function _default() {
      return [2, 2, 3, 4];
    },
    type: [Number, String, Object, Array]
  }
})(_templateObject4(), fontSize);
var BlockLiner = styled("div", {})(_templateObject5());
var BlockTitle = styled("h3", {})(_templateObject6());
var BlockBody = styled("p", {})(_templateObject7());

var script = {
  props: {
    copy: {
      required: true,
      type: Object
    }
  },
  computed: _extends({}, mapState("viewport", ["breakpoint"])),
  methods: {
    findBreakpointBackground: function findBreakpointBackground() {
      var _this = this;

      var match = this.copy.backgrounds.find(function (item) {
        return item.breakpoints.indexOf(_this.breakpoint) !== -1;
      });
      return match ? match.background : null;
    }
  },
  render: function render() {
    var h = arguments[0];
    // Find background style that best matches given breakpoint
    var background = this.findBreakpointBackground(); // Add background image and inset drop shadow to section element

    var centerStyle = {
      background: background // backgroundSize: "100% 100%",

    }; // Render multiple panels

    var renderPanels = function renderPanels(panels) {
      return panels.map(function (panel, panelIndex) {
        return h(Col, {
          "attrs": {
            "width": [12, 12, 12, 4, 4]
          }
        }, [h(Block, [h(BlockLiner, [h(BlockTitle, [panel.title]), panel.copy.map(function (copy, copyIndex) {
          return h(BlockBody, {
            "key": copyIndex
          }, [copy]);
        }), panel.image && h("img", {
          "style": {
            maxHeight: "40px",
            marginTop: "20px"
          },
          "attrs": {
            "src": panel.image.url,
            "alt": panel.image.alt
          }
        })])])]);
      });
    }; // Render component


    return h(Section, [h(Center, {
      "attrs": {
        "flexDirection": "column"
      },
      "style": centerStyle
    }, [h(SectionHeader, [this.copy.header]), h(Row, [renderPanels(this.copy.panels)]), h(SectionFooter, [h("div", {
      "style": {
        margin: "20px"
      }
    }, [this.copy.footer])])])]);
  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function (context) {
      style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

/* script */
const __vue_script__ = script;

/* template */

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = undefined;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = normalizeComponent(
    {},
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
